import React from 'react';

export default function Loader({ className = 'mx-auto w-24 p-4' }: { className?: string }) {
  return (
    <div className={`animate-pulse ${className}`}>
      {/*<img className='mx-auto ' src='/placeholder.svg' />*/}
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='w-full h-full'
      >
        <path
          d='M22.9793 7.28901L23 7.29704V1.94588C23 0.871198 22.204 0 21.2222 0H2.77778C1.79594 0 1 0.871198 1 1.94588V7.29704L1.00131 7.29655C1.00043 7.34456 1 7.39272 1 7.44098V24H5.40411V7.4368C5.40411 7.11335 5.45991 6.81091 5.57151 6.52944C5.68311 6.24801 5.83853 6.00434 6.03782 5.79433C6.23711 5.58428 6.46827 5.42048 6.73529 5.30285C7.00236 5.18523 7.28929 5.12641 7.59618 5.12641C7.90311 5.12641 8.19004 5.18523 8.45711 5.30285C8.72413 5.42048 8.95529 5.58428 9.15458 5.79433C9.35387 6.00434 9.50929 6.24801 9.62089 6.52944C9.73249 6.81091 9.78827 7.11335 9.78827 7.4368V24H14.1924V7.4368C14.1924 7.11335 14.2482 6.81091 14.3598 6.52944C14.4714 6.24801 14.6268 6.00434 14.8261 5.79433C15.0254 5.58428 15.2565 5.42048 15.5236 5.30285C15.7906 5.18523 16.0776 5.12641 16.3845 5.12641C16.6914 5.12641 16.9783 5.18523 17.2454 5.30285C17.5124 5.42048 17.7436 5.58428 17.9428 5.79433C18.1421 6.00434 18.3016 6.24801 18.4172 6.52944C18.5327 6.81091 18.5925 7.11335 18.5925 7.4368V24H22.9807V7.4368C22.9807 7.38737 22.9802 7.33814 22.9793 7.28901Z'
          fill='#151515'
        />
      </svg>
    </div>
  );
}
